import type { Grade, GradedEpisode, JudgeTag } from "../../desk-records";

function judgeTag(value: unknown): JudgeTag | null {
  return value === "post" || value === "hold" || value === "pass"
    ? value
    : null;
}

function textValue(value: unknown): string | null {
  return typeof value === "string" && value ? value : null;
}

function craftDetails(value: unknown): Pick<Grade, "tag" | "notes" | "winces"> {
  const craft =
    value && typeof value === "object" && "craft" in value ? value.craft : null;

  if (!craft || typeof craft !== "object")
    return { tag: null, notes: null, winces: [] };

  const flags = "cringe_flags" in craft ? craft.cringe_flags : undefined;
  return {
    tag: judgeTag("tag" in craft ? craft.tag : undefined),
    notes: textValue("notes" in craft ? craft.notes : undefined),
    winces: Array.isArray(flags)
      ? flags.filter((flag): flag is string => typeof flag === "string")
      : [],
  };
}

/** The seat's grade out of one episode's results, or null when the seat is not there. */
export function gradeFromResults({
  episode,
  policyVersionId,
}: {
  readonly episode: GradedEpisode;
  readonly policyVersionId: string;
}): Grade | null {
  const seat = episode.policyVersionIds.indexOf(policyVersionId);

  if (seat < 0 || !episode.results) return null;

  const results = episode.results;
  const seatValue = (key: string): unknown => {
    const values = results[key];
    return Array.isArray(values) ? values[seat] : undefined;
  };
  const score = seatValue("scores");

  if (typeof score !== "number") return null;

  const editor = seatValue("judge");
  const ships = seatValue("room_ships");
  return {
    score: Math.round(score * 10) / 10,
    editor: typeof editor === "number" ? Math.round(editor * 10) / 10 : 0,
    ...craftDetails(seatValue("judge_records")),
    verdict: textValue(seatValue("verdicts")),
    roomShips: typeof ships === "number" ? ships : null,
    posted: seatValue("posted") === true,
    tweetId: textValue(seatValue("tweet_ids")),
    gradedAt: episode.completedAt,
    episodeId: episode.episodeId,
  };
}
